import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getSnapshotData } from "../../api/snapshot";

const Snapshot = ({ components, insurance, onDataFetchError, gotoDetails }) => {
  let [loadingInProgress, setLoadingProcess] = useState(true);
  let [snapshotData, setSnapshotData] = useState(null);

  useEffect(() => {
    if (insurance?.memberId) {
      getSnapshotData(insurance).then(results => {
        if (results) {
          setSnapshotData(results.data.summary);
        } else {
          onDataFetchError();
        }
        setLoadingProcess(false);
      });
    } else {
      setLoadingProcess(false);
    }
  }, []);

  const wrapAddLabel = (text, child) => (
    <div className='snapshot-data-web-sdk'>
      <components.Label text={text} />
      {child}
    </div>
  );

  const getPercentage = data => {
    return (data.applied.amount / data.limit.amount) * 100;
  };

  const formSnapshotTextData = (type, data, returnType) => {
    const dataToOperate =
      type === "inNetwork" ? data.inNetwork : data.outOfNetwork;
    const percentage = getPercentage(dataToOperate);
    switch (returnType) {
      case "text":
        return `$${dataToOperate.applied.amount} used of $${dataToOperate.limit.amount}`;
      case "data":
        return Number.isNaN(percentage) ? 0 : percentage.toFixed(2);
      case "bottomText":
        return `$${
          Number.isNaN(percentage) ? 0 : percentage.toFixed(2)
        } Toward in network deductible`;
    }
  };

  const drawChartWithData = type => {
    const dataToOperate =
      type === "Individual"
        ? snapshotData.summary.deductible.individual
        : snapshotData.summary.deductible.family;

    return (
      <div className='snapshot-data-wrapper-web-sdk'>
        <components.PieChart
          header={`${type} snapshot`}
          data={formSnapshotTextData("inNetwork", dataToOperate, "data")}
          doughnutHoleSize={0.5}
        />
        <components.Text
          label={`${formSnapshotTextData(
            "inNetwork",
            dataToOperate,
            "bottomText"
          )}`}
        />
        {wrapAddLabel(
          "In network",
          <components.Text
            label={`${formSnapshotTextData(
              "inNetwork",
              dataToOperate,
              "text"
            )}`}
          />
        )}
        {wrapAddLabel(
          "Out of network",
          <components.Text
            label={`${formSnapshotTextData(
              "outOfNetwork",
              dataToOperate,
              "text"
            )}`}
          />
        )}
      </div>
    );
  };

  const formCopayHeader = string => {
    const stringToReturn = string.split("_").join(" ");
    return stringToReturn.charAt(0).toUpperCase() + stringToReturn.slice(1);
  };

  const formCopay = () => {
    const inNetwork = snapshotData.coverage.copay.filter(
      item => item.inPlanNetwork === "yes"
    );
    const outOfNetwork = snapshotData.coverage.copay.filter(
      item => item.inPlanNetwork === "no"
    );
    return (
      <>
        <div className='copay-in-network-web-sdk'>
          <components.Text
            label='Employee and children, in plan network'
            params='copay-header-web-sdk'
          />
          {inNetwork.map(item => {
            return wrapAddLabel(
              formCopayHeader(item.serviceTypes[0]),
              <components.Text label={`Copay $${item.copayment.amount}`} />
            );
          })}
        </div>
        <div className='copay-out-of-network-web-sdk'>
          <components.Text
            label='Employee and children, out of plan network'
            params='copay-header-web-sdk'
          />
          {outOfNetwork.map(item => {
            return wrapAddLabel(
              formCopayHeader(item.serviceTypes[0]),
              <components.Text label={`Copay $${item.copayment.amount}`} />
            );
          })}
        </div>
      </>
    );
    return null;
  };

  return (
    <>
      {loadingInProgress ? (
        <components.Loader />
      ) : insurance && snapshotData ? (
        <div className='snapshot-insurance-web-sdk'>
          {wrapAddLabel(
            "Insurance card",
            <components.Text
              label={`${snapshotData.subscriber.firstName} ${snapshotData.subscriber.lastName}`}
            />
          )}
          <div className='insurer-data-web-sdk'>
            {wrapAddLabel(
              "Insurer",
              <components.Text label={`${snapshotData.payer.name}`} />
            )}

            {wrapAddLabel(
              "Group ID",
              <components.Text label={`${snapshotData.coverage.groupNumber}`} />
            )}

            {wrapAddLabel(
              "Plan",
              <components.Text
                label={`${snapshotData.coverage.planDescription}`}
              />
            )}

            {wrapAddLabel(
              "Effective",
              <components.Text
                label={`${snapshotData.coverage.planBeginDate
                  .split("-")
                  .join("/")}`}
              />
            )}

            {wrapAddLabel(
              "Member ID",
              <components.Text label={`${snapshotData.subscriber.id}`} />
            )}
          </div>
          <div className='snapshots-wrapper-web-sdk'>
            {snapshotData.summary.outOfPocket.individual
              ? drawChartWithData("Individual")
              : null}

            {snapshotData.summary.outOfPocket.family
              ? drawChartWithData("Family")
              : null}
          </div>
          <div className='snapshot-copay-web-sdk'>{formCopay()}</div>
        </div>
      ) : (
        <div className='snapshot-no-info-web-sdk'>
          <components.Text label='Please update insurance information on the' />
          <components.Text
            onClick={() => gotoDetails(1)}
            label='Details tab'
            params='to-detail-tab-web-sdk'
          />
        </div>
      )}
    </>
  );
};

Snapshot.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  components: PropTypes.object
};

export default Snapshot;
